import React from 'react';
import Header from '../../Shared/Header/Header';
import Banner from '../Banner/Banner';

import HomeProjects from './HomeProjects';

const Home = () => {
    return (
        <div>
            <Banner></Banner>
        </div>
    );
};

export default Home;